import axios from "axios";
import { CASTTREE_BASE_URL } from "../helper/video-uploader.helper";
import { APP_CONSTANTS, ENV } from "../const/app.const";

const ENV_VARIABLES = APP_CONSTANTS[ENV];

const CASTTREE_SERVICE_BASE_URL = ENV_VARIABLES.CASTTREE_SERVICE_BASE_URL;
const CASTTREE_MONGODB_BASE_URL = ENV_VARIABLES.CASTTREE_MONGODB_BASE_URL;

// Prod
// const base_url = "https://prodapi.casttree.com";

axios.interceptors.response.use(null, (error) => {
  console.log("interceptor erro is", error);
  if (
    error.response.status === 401 &&
    error.config.url.includes(CASTTREE_BASE_URL)
  ) {
    authService.doLogout();
  }
  throw error;
});

const authService = {
  doLogout: () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("peertube_token");
    localStorage.removeItem("rzp_device_id");
    localStorage.removeItem("rzp_checkout_anon_id");
    localStorage.removeItem("user_detail");
    localStorage.removeItem("user_data");
    localStorage.removeItem("fileUploadDetail");
    localStorage.removeItem("peertubeToken");
    localStorage.removeItem("peertubeDefaultChannel");
    localStorage.removeItem("user_otpResponse_data");
    localStorage.removeItem("user_profile_filter_data");
    window.location.reload();
  },
  generateOTP: async (phoneNumber) => {
    try {
      const response = await axios.post(
        `${CASTTREE_SERVICE_BASE_URL}/casttree/auth/generate-otp/Phone`,
        {
          country: "IN",
          extension: "+91",
          phoneNumber: phoneNumber,
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  otpLogin: async (phoneNumber, otp) => {
    try {
      const headers = {
        "Content-Type": "application/json", 
        "UserMode": "web",
      };
      const response = await axios.post(
        `${CASTTREE_SERVICE_BASE_URL}/casttree/auth/otp-login/Phone`,
        {
          phoneCountryCode: "+91",
          phoneNumber: phoneNumber,
          otp: otp,
        },
        { headers }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getStateList: async (search, skip = 0, limit = 500) => {
    const requestBody = {
      search: "",
      skip: skip,
      limit: limit,
    };
    const response = await axios.post(
      `${CASTTREE_SERVICE_BASE_URL}/casttree/state/get-states`,
      requestBody
    );
    return response.data;
  },

  getCityList: async (stateId, skip = 0, limit = 1500) => {
    const response = await axios.get(
      `${CASTTREE_SERVICE_BASE_URL}/casttree/city?state=${stateId}&skip=${skip}&limit=${limit}`
    );
    return response.data;
  },

  userDetailUpdate: async (user_id) => {
    const requestBody = {
      user_id: user_id,
    };
    const response = await axios.post(
      `${CASTTREE_SERVICE_BASE_URL}/casttree/user/get-user-detail`,
      requestBody
    );
    return response.data;
  },

  updateUserData: async (userData) => {
    const token = localStorage.getItem("access_token");
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Assuming JSON data
    };
    const response = await axios.patch(
      `${CASTTREE_SERVICE_BASE_URL}/casttree/user/update-user`,
      userData,
      { headers }
    );
    return response.data;
  },

  projectCategoryList: async (search) => {
    const requestBody = {
      search: "",
      category_type: "event",
    };
    const response = await axios.post(
      `${CASTTREE_SERVICE_BASE_URL}/casttree/category/get-category-list`,
      requestBody
    );
    return response.data;
  },

  languageLists: async (skip = 0, limit = 1000) => {
    const token = localStorage.getItem("access_token");
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Assuming JSON data
    };
    const response = await axios.get(
      `${CASTTREE_SERVICE_BASE_URL}/casttree/language?skip=${skip}&limit=${limit}`,
      { headers }
    );
    return response.data;
  },

  getGenreList: async (categoryId) => {
    const response = await axios.get(
      `${CASTTREE_SERVICE_BASE_URL}/casttree/genres/get-genres?category=${categoryId}`
    );
    return response;
  },

  saveProject: async (projectData) => {
    const token = localStorage.getItem("access_token");
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Assuming JSON data
    };
    const response = await axios.post(
      `${CASTTREE_SERVICE_BASE_URL}/casttree/project/save-project`,
      projectData,
      { headers }
    );
    return response.data;
  },

  getAwardList: async (categoryId) => {
    const response = await axios.get(
      `${CASTTREE_SERVICE_BASE_URL}/casttree/awards/get-awards?category=${categoryId}`
    );
    return response.data;
  },

  saveApplication: async (appData) => {
    const token = localStorage.getItem("access_token");
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Assuming JSON data
    };
    const response = await axios.post(
      `${CASTTREE_SERVICE_BASE_URL}/casttree/application/save-application`,
      appData,
      { headers }
    );
    return response.data;
  },

  getApplicationsList: async (project_id) => {
    const token = localStorage.getItem("access_token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const response = await axios.get(
      `${CASTTREE_SERVICE_BASE_URL}/casttree/application/get-application/${project_id}`,
      { headers }
    );
    return response.data;
  },

  addNominations: async (nominationData) => {
    const token = localStorage.getItem("access_token");
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Assuming JSON data
    };
    const response = await axios.post(
      `${CASTTREE_SERVICE_BASE_URL}/casttree/nominations/add-nominations`,
      nominationData,
      { headers }
    );
    return response.data;
  },

  getCouponList: async (couponList) => {
    const response = await axios.post(
      `${CASTTREE_SERVICE_BASE_URL}/casttree/coupon/get-coupon-list`,
      couponList
    );
    return response.data;
  },

  applyCoupon: async (applyCouponData) => {
    const token = localStorage.getItem("access_token");
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Assuming JSON data
    };
    const response = await axios.post(
      `${CASTTREE_SERVICE_BASE_URL}/casttree/coupon/apply-coupon`,
      applyCouponData,
      { headers }
    );
    return response.data;
  },

  getProjectList: async (skip = 0, limit = 100) => {
    const token = localStorage.getItem("access_token");
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Assuming JSON data
    };
    const response = await axios.get(
      `${CASTTREE_SERVICE_BASE_URL}/casttree/project/get-projects?skip=${skip}&limit=${limit}&searchAcrossCrew=false`,
      { headers }
    );
    return response.data;
  },

  getProjectDetail: async (project_id) => {
    const token = localStorage.getItem("access_token");
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Assuming JSON data
    };
    const response = await axios.get(
      `${CASTTREE_SERVICE_BASE_URL}/casttree/project/get-project/${project_id}`,
      { headers }
    );
    return response.data;
  },

  paymentRequestInitiate: async (paymentInitiateData) => {
    const token = localStorage.getItem("access_token");
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Assuming JSON data
    };
    const response = await axios.patch(
      `${CASTTREE_SERVICE_BASE_URL}/casttree/application/payment`,
      paymentInitiateData,
      { headers }
    );
    return response.data;
  },

  paymentSuccess: async (paymentSuccessData) => {
    const token = localStorage.getItem("access_token");
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Assuming JSON data
    };
    const response = await axios.post(
      `${CASTTREE_SERVICE_BASE_URL}/casttree/application/success`,
      paymentSuccessData,
      { headers }
    );
    return response.data;
  },

  deleteProject: async (project_id) => {
    const token = localStorage.getItem("access_token");
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Assuming JSON data
    };
    const response = await axios.delete(
      `${CASTTREE_SERVICE_BASE_URL}/casttree/project/${project_id}`,
      { headers }
    );
    return response.data;
  },

  getCommunityJoinChennal: async () => {
    const response = await axios.get(
      `${CASTTREE_MONGODB_BASE_URL}/app/casttree-ydwxcuo/endpoint/whatsappGroup`
    );
    return response.data;
  },

  getPromotionalDetail: async (processId) => {
    const token = localStorage.getItem("access_token");
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Assuming JSON data
    };
    const response = await axios.get(
      `${CASTTREE_SERVICE_BASE_URL}/casttree-oms/service-item/getPromotionDetails/${processId}`,
      { headers }
    );
    return response.data;
  },

  createCourseSubscription: async (body) => {
    const token = localStorage.getItem("access_token");
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const response = await axios.post(
      `${CASTTREE_SERVICE_BASE_URL}/casttree-oms/subscription`,
      body,
      { headers }
    );
    return response.data;
  },

  getProfileDetail: async (profileId) => {
    try {
      const token = localStorage.getItem("access_token");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.get(
        `${CASTTREE_SERVICE_BASE_URL}/casttree/profile/${profileId}`,
        { headers }
      );
      return response.data;
    } catch (error) {
      console.log("Error fetching profile detail:", error);
      throw error;
    }
  },

  initiateSubscriptionRazorpay: async (processId) => {
    // 1. Fetch promotional details
    const { APP_CONSTANTS, ENV } = await import("../const/app.const");
    const ENV_VARIABLES = APP_CONSTANTS[ENV];
    const promotionalRes = await axios.get(
      `${CASTTREE_SERVICE_BASE_URL}/casttree-oms/service-item/getPromotionDetails/${processId}`,
      { headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` } }
    );
    const promotionalData = promotionalRes.data;
    // 2. Create subscription
    const subscriptionBody = {
      planId: promotionalData?.planId,
      provider: "razorpay",
      authAmount: promotionalData?.isNewSubscriber
        ? promotionalData?.authDetail?.amount
        : promotionalData?.subscriptionDetail?.amount,
      validity: promotionalData?.isNewSubscriber
        ? promotionalData?.authDetail?.validity
        : promotionalData?.subscriptionDetail?.validity,
      validityType: promotionalData?.isNewSubscriber
        ? promotionalData?.authDetail?.validityType
        : promotionalData?.subscriptionDetail?.validityType,
      sourceId: processId,
      sourceType: "process",
      itemId: promotionalData?.itemId,
      providerId: "1",
    };
    const subscriptionResponse = await authService.createCourseSubscription(subscriptionBody);
    // 3. Open Razorpay modal
    return new Promise((resolve, reject) => {
      const userDetail = JSON.parse(localStorage.getItem("user_detail") || "{}");
      const rzp = new window.Razorpay({
        key: ENV_VARIABLES.RAZOR_PAY_KEY,
        name: "Creedom",
        order_id: subscriptionResponse?.data?.subscriptionDetails?.id,
        customer_id: subscriptionResponse?.data?.subscriptionDetails?.customerId,
        recurring: "1",
        notes: {
          userId: userDetail?.user?._id,
          userReferenceId: subscriptionResponse?.data?.subscriptionDetails?.customerId,
          razorpayOrderId: subscriptionResponse?.data?.subscriptionDetails?.id,
        },
        theme: { color: "#3399cc" },
        method: {
          upi: true,
          card: true,
          netbanking: true,
          wallet: true,
          emi: false,
          emandate: false,
          paylater: false,
        },
        prefill: {
          email: userDetail?.user?.emailId || `${userDetail?.user?.phoneNumber}@gmail.com`,
          contact: userDetail?.user?.phoneNumber,
          name: userDetail?.user?.userName,
        },
        handler: async function (response) {
          // 4. Update user profile after payment
          try {
            const userProfileFilterData = JSON.parse(localStorage.getItem("user_profile_filter_data") || "{}");
            const profileId = userProfileFilterData?._id;
            if (profileId) {
              const updatedUserData = await authService.getProfileDetail(profileId);
              localStorage.setItem("profileDetail", JSON.stringify(updatedUserData));
            }
          } catch (e) { /* ignore */ }
          resolve(response);
        },
        modal: {
          ondismiss: function () {
            reject(new Error("Payment popup closed"));
          },
        },
      });
      rzp.open();
    });
  },
};

export default authService;
